import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_141: FaireProductEntity = {
  token: "legacy_prod_abbott-141",
  type: "product",
  name: "Butterfly Garden Canister-5.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/39ae98235145264d3d747dca96ad5eb770e94bbf84de32c4e4ed7cc8511f46c9.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
